/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.small-success-message[_ngcontent-%COMP%] {\n  font-size: 12px;\n  font-family: "Slabo 27px", Arial, Helvetica, sans-serif;\n  color: #5cb85c;\n}\n.invite-container[_ngcontent-%COMP%] {\n  position: relative;\n}\n.box-control[_ngcontent-%COMP%] {\n  position: relative;\n}\n@media (min-width: 769px) {\n  .box-control[_ngcontent-%COMP%] {\n    max-width: 400px;\n  }\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL3Byb2ZpbGUvcHJvZmlsZS5jb21wb25lbnQubGVzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2N1c3RvbS9wcm9maWxlL3Byb2ZpbGUuY29tcG9uZW50Lmxlc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/custom/profile/profile.component.less.shim.ngstyle.ts